var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.expandedTooltips.isActive,
          expression: "expandedTooltips.isActive"
        }
      ],
      ref: "expandedTipContainer",
      staticClass: "expanded-tip-container"
    },
    [
      _c("div", {
        staticClass: "background-container",
        on: {
          click: function($event) {
            _vm.hideExpandedTooltip()
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "arrow", style: _vm.arrowTransformation }),
      _vm._v(" "),
      _c("div", {
        staticClass: "arrow-shadow",
        style: _vm.arrowTransformation
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "expanded-tip-wrapper",
          style: _vm.expandedTipContainerTransformation
        },
        [
          _c("div", { staticClass: "title" }, [
            _c(
              "i",
              {
                staticClass: "material-icons close",
                on: {
                  click: function($event) {
                    _vm.hideExpandedTooltip()
                  }
                }
              },
              [_vm._v("close")]
            ),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.content) } })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-340e5b4d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340e5b4d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/tooltip-expanded.vue
// module id = null
// module chunks = 